// extracted by mini-css-extract-plugin
module.exports = {"container":"XOT9LMtHKd_fXmfFpCNkY","verticalMargin":"_24nq9MqwGgEArJOLaGlaY0"};